export default {
  failed_to_create_session: 'Failed to create session',
  failed_to_send_file_type_message: 'Failed to send file type message',
  failed_to_send_message: 'Failed to send message',
  illegal_requests_will_be_banned: 'Illegal requests will be banned',
  linkchat_initialization_failed: 'LINKCHAT initialization failed',
  no_queued_data_return: 'No queued data return',
  no_session_created: 'No session created',
  no_token: 'No token',
  non_existent_session_id: 'Non-existent session ID',
  queuing_timeout: 'Queuing timeout',
  sdk_authentication_failed: 'SDK authentication failed',
  'server_deserted_({status})': 'Server deserted ({status})',
  session_reconnection_failed: 'Session reconnection failed',
  sorry__the_gateway_timed_out: 'Sorry, the gateway timed out',
  'sorry__there_is_a_problem_with_the_program_({status})':
    'Sorry, there is a problem with the program ({status})',
  the_amount_of_data_you_are_requesting_is_too_large:
    'The amount of data you are requesting is too large',
  the_current_session_is_not_in_progress:
    'The current session is not in progress',
  the_resource_you_requested_does_not_exist:
    'The resource you requested does not exist',
  the_resource_you_requested_is_denied_access:
    'The resource you requested is denied access',
  the_session_has_ended__reconnection_failed__click_try_again:
    'The session has ended, reconnection failed, click Try again',
  unrecognized_authentication_token: 'Unrecognized authentication token',
  input_placeholder: 'Please enter the question~',
  cancel_queue:
    'Failed to cancel the queue. Please refresh the page and try again~',
  queue_header: 'You are at the top of the queue and will be connected to ~',
  queue_before: 'In the queue, there are',
  queue_after: 'people in front of you. Please wait!',
  queue_close: 'Exit queue',
  operation_failed: 'Operation Failed!',
  message_wrong: 'The message is wrong',
  message_read: 'read',
  message_unread: 'unread',
  fail_to_end_session: 'Failed to end session',
  close_session: 'Close session',
  close_session_tip:
    'This session will end after closing. Are you sure you want to close it?',
  pc_title: 'Online Service',
  not_support_message:
    'The current client does not support this type of message',
  order_card_error: 'Order card analysis error',
  message_recalled: 'This message has been recalled',
  guess_you_want_to_ask: 'Guess you want to ask',
  customer_service: 'customer service',
  customer_service2: 'customer service',
  loading: 'loading',
  uploading: 'uploading',
  downloading: 'downloading',
  sending: 'sending',
};
